import { css } from "styled-components";
import { spaceMixin } from "../spaceMixin";
import { StyledFormField } from "../../components/FormField/FormField";
import { StyledFormActions } from "../../components/FormActions/FormActions";
/** @class FormMixin */

/** @method */

export var FormMixin = function FormMixin(props) {
  return css(["", ":not(:last-child){margin-bottom:", ";}", "{margin-top:", ";}"], StyledFormField, spaceMixin("sm")(props), StyledFormActions, spaceMixin("lg")(props));
};